var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecureAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 64,
    viewBox: "0 0 56 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74807 6.79654C7.22267 6.79654 6.79656 7.22254 6.79656 7.74815V50.2265C6.79656 50.7521 7.22267 51.1781 7.74807 51.1781H67.2519C67.7773 51.1781 68.2034 50.7521 68.2034 50.2265V7.74815C68.2034 7.22254 67.7773 6.79654 67.2519 6.79654H7.74807ZM0 7.74815C0 3.46913 3.46882 0 7.74807 0H67.2519C71.5312 0 75 3.46913 75 7.74815V50.2265C75 54.5055 71.5312 57.9746 67.2519 57.9746H7.74807C3.46882 57.9746 0 54.5055 0 50.2265V7.74815Z",
    fill: "#0F20E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4823 51.1777C39.3591 51.1777 40.8805 52.6992 40.8805 54.576V71.6014C40.8805 73.4782 39.3591 74.9996 37.4823 74.9996C35.6054 74.9996 34.084 73.4782 34.084 71.6014V54.576C34.084 52.6992 35.6054 51.1777 37.4823 51.1777Z",
    fill: "#0F20E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.584 21.6121C23.584 19.7353 25.1054 18.2139 26.9823 18.2139H48.0176C49.8944 18.2139 51.4158 19.7353 51.4158 21.6121C51.4158 23.4889 49.8944 25.0104 48.0176 25.0104H26.9823C25.1054 25.0104 23.584 23.4889 23.584 21.6121Z",
    fill: "#0F20E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.584 37.3465C23.584 35.4697 25.1054 33.9482 26.9823 33.9482H48.0176C49.8944 33.9482 51.4158 35.4697 51.4158 37.3465C51.4158 39.2233 49.8944 40.7448 48.0176 40.7448H26.9823C25.1054 40.7448 23.584 39.2233 23.584 37.3465Z",
    fill: "#0F20E8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureAddress);
export default __webpack_public_path__ + "static/media/secure_address.47a00da7f1439de3b35e032f7e4b480e.svg";
export { ForwardRef as ReactComponent };